export default {
  '@type': 'MerchantReturnPolicy',
  'applicableCountry': 'CH',
  'merchantReturnLink': 'https://www.timberland.ch/de-ch/kundenservice/ruckversand',
  'returnPolicyCategory': 'https://schema.org/MerchantReturnFiniteReturnWindow',
  'returnMethod': 'https://schema.org/ReturnByMail',
  'merchantReturnDays': 30
}
